import Vue from 'vue'

// Lib imports
import axios from 'axios'

if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'https://api.betacore.nl/'
} else {
    axios.defaults.baseURL = 'http://localhost:5000/'
}

Vue.prototype.api = axios
